/**
 * The sign in / create account overlay. Canvas: a centred 460px dialog on a 50% scrim from
 * 960px (radius 18, max 86% tall); the auth panel's own bottom sheet below that.
 */
import styled from '@emotion/styled';
import { Box, Dialog } from '@mui/material';
import { withAlpha } from '../../../../Utils/dfcBrand';
import { SurfaceProp, omit } from '../style';

export const OverlayDialog = styled(Dialog, omit('surface'))<SurfaceProp>`
  & .MuiDialog-paper {
    width: 460px;
    max-width: calc(100% - 32px);
    max-height: 86vh;
    margin: 16px;
    border-radius: 18px;
    background: ${({ surface }) => surface.panel};
    background-image: none;
    color: ${({ surface }) => surface.ink};
    border: 1px solid ${({ surface }) => surface.border};
    box-shadow: 0 18px 50px ${({ surface }) => withAlpha(surface.scrim, 0.28)};
  }

  & .MuiBackdrop-root {
    background: ${({ surface }) => withAlpha(surface.scrim, 0.5)};
    backdrop-filter: blur(2px);
  }
`;

/**
 * Holds the panel (rendered `inline`, so it brings no chrome of its own) and the close
 * control. `Register` wraps everything in a page-sized `RegisterWrapper`; its page margins
 * are cancelled here so the panel sits flush in the overlay.
 */
export const OverlayBody = styled(Box)`
  position: relative;
  padding: 32px 24px 28px;

  @media (min-width: 600px) {
    padding: 32px;
  }

  [data-testid='register-wrapper'] {
    max-width: none;
    margin: 0;
    padding: 0;
  }
`;
